module.exports = __webpack_public_path__ + "static/img/desktop-zhgl.47c540d0.png";